import { PaymentTypeModel } from '@app/src/views/CipReport/filter/models/PaymentType';
import { PaymentTypeService } from '@app/src/views/CipReport/filter/models/PaymentTypeService';

export const hydratePaymentType = (data: PaymentTypeService): PaymentTypeModel => {
  let paymentType = data.data.map((paymentType) => {
    let metadata = paymentType.metadata ? { metadata: paymentType.metadata } : {}
    return {
      value: paymentType.paymentTypeId.toString(),
      label: paymentType.paymentType,
      ...metadata
    };
  });

  const dataHydrate: PaymentTypeModel = {
    code: data.code,
    message: data.message,
    paymentType: paymentType
  };

  return dataHydrate;
}
